export const volumes = [
  {
    number: "I",
    color: "#1C4FA0",
    title: "The Renal Physiology & Kidney Function Guide",
    tagline: "Build a structured foundation for understanding the relationship between kidney function and nutritional health.",
    body: [
      "Understanding kidney physiology provides important context for studying renal nutrition.",
      "In this volume, I’ve organized educational references covering kidney function, fluid balance, electrolyte regulation, and the physiological concepts that influence nutritional considerations in kidney-related conditions.",
    ],
    topics: [
      "Kidney anatomy and physiological functions",
      "Glomerular filtration and renal function concepts",
      "Fluid balance and homeostasis",
      "Electrolyte regulation fundamentals",
      "Acid-base balance educational concepts",
      "Kidney function indicators and terminology",
      "Overview of acute and chronic kidney conditions",
      "Relationships between kidney function and nutritional status",
      "Renal physiology diagrams and reference summaries",
    ],
    note: "This volume provides foundational educational material to help you organize your understanding of kidney function and its relationship to nutrition.",
  },
  {
    number: "II",
    color: "#1D7A55",
    title: "The Renal Nutrition Assessment Blueprint",
    tagline: "Organize the key elements involved in studying nutritional status in kidney-related conditions.",
    body: [
      "Renal nutrition assessment requires consideration of multiple sources of information.",
      "Dietary intake, weight trends, nutritional history, relevant laboratory findings, and individual circumstances can all contribute to a broader understanding of nutritional status.",
      "In this volume, I’ve brought together educational frameworks designed to help you study these assessment components in a more structured way.",
    ],
    topics: [
      "Renal nutrition assessment fundamentals",
      "Dietary history review frameworks",
      "Anthropometric assessment concepts",
      "Weight trends and nutritional risk considerations",
      "Protein-energy wasting educational references",
      "Relevant laboratory markers and their limitations",
      "Dietary intake documentation worksheets",
      "Nutrition-focused assessment frameworks",
      "Malnutrition screening educational concepts",
      "Structured assessment case exercises",
    ],
    note: "These materials support educational review and do not replace comprehensive clinical assessment or validated assessment methods.",
  },
  {
    number: "III",
    color: "#9A6A0B",
    title: "The Renal Dietary Management & Nutrient Reference Guide",
    tagline: "Study the nutritional considerations that frequently arise in renal nutrition practice.",
    body: [
      "Renal nutrition involves more than memorizing dietary restrictions.",
      "Nutritional considerations can vary according to kidney function, treatment modality, nutritional status, comorbidities, medications, and individual needs.",
      "This volume organizes educational references covering major nutrient-related concepts and the considerations professionals study when evaluating renal dietary approaches.",
    ],
    topics: [
      "Protein and energy requirements: foundational concepts",
      "Sodium intake and fluid balance considerations",
      "Potassium metabolism and dietary sources",
      "Phosphorus metabolism and food-related considerations",
      "Dietary phosphorus and bioavailability concepts",
      "Fluid management educational references",
      "Carbohydrate and fat considerations in renal nutrition",
      "Food label interpretation exercises",
      "Nutrient comparison tables",
      "Educational references on dietary patterns and food selection",
    ],
    note: "Nutrient requirements and dietary recommendations must be individualized. This volume does not prescribe a universal renal diet or replace current evidence-based guidance.",
  },
  {
    number: "IV",
    color: "#A3222A",
    title: "The Renal Nutrition Care Planning Workbook",
    tagline: "Organize the educational considerations involved in renal nutrition care planning.",
    body: [
      "Developing an appropriate nutrition care plan involves bringing together assessment findings, nutritional priorities, individual circumstances, and relevant clinical guidance.",
      "I designed this volume to help you organize these considerations through structured educational worksheets and case-based exercises.",
    ],
    topics: [
      "Nutrition care planning fundamentals",
      "Nutrition problem identification frameworks",
      "Nutrition diagnosis educational examples",
      "Individualized nutrition goal-setting worksheets",
      "Dietary intervention planning considerations",
      "Nutrition counseling preparation templates",
      "Patient education planning frameworks",
      "Monitoring and evaluation concepts",
      "Nutrition care process documentation worksheets",
      "Hypothetical renal nutrition case exercises",
    ],
    note: "These resources support educational planning and professional discussion. They do not generate individualized treatment prescriptions or replace qualified clinical decision-making.",
  },
  {
    number: "V",
    color: "#5B2BA0",
    title: "The Renal Nutrition Clinical Case Analysis Guide",
    tagline: "Develop a more structured approach to studying complex renal nutrition scenarios.",
    body: [
      "Renal nutrition cases often involve overlapping clinical and nutritional considerations.",
      "Understanding how these factors interact requires more than reviewing isolated facts. It involves organizing the available information, identifying relevant questions, and evaluating the case within its appropriate clinical context.",
      "This volume brings together hypothetical educational scenarios and structured case-review frameworks.",
    ],
    topics: [
      "Chronic kidney disease nutrition case studies",
      "Acute kidney injury nutrition considerations",
      "Hemodialysis nutrition education scenarios",
      "Peritoneal dialysis nutrition case exercises",
      "Kidney transplant nutrition education cases",
      "Diabetes and kidney disease case analysis",
      "Electrolyte-related educational scenarios",
      "Nutrition risk identification exercises",
      "Clinical information review frameworks",
      "Structured case discussion worksheets",
    ],
    note: "The cases are educational examples designed to support learning. They are not validated treatment protocols or individualized medical recommendations.",
  },
  {
    number: "VI",
    color: "#1F5FB0",
    title: "The Renal Nutrition Monitoring & Documentation Guide",
    tagline: "Bring greater structure to nutrition records, monitoring, and follow-up documentation.",
    body: [
      "Nutrition assessment and care planning involve information that may need to be reviewed over time.",
      "Dietary intake, nutritional status, relevant laboratory findings, clinical changes, and follow-up observations can all form part of the professional documentation process.",
      "In this volume, I’ve organized educational resources designed to help you study documentation and monitoring practices.",
    ],
    topics: [
      "Renal nutrition consultation templates",
      "Dietary assessment documentation frameworks",
      "Nutrition care plan record templates",
      "Nutritional status monitoring worksheets",
      "Weight trend documentation tools",
      "Dietary intake follow-up forms",
      "Nutrition counseling record templates",
      "Nutrition intervention monitoring frameworks",
      "Follow-up assessment worksheets",
      "Educational case review documentation",
    ],
    note: "All templates should be adapted to your professional scope, local documentation requirements, privacy obligations, and applicable clinical standards.",
  },
];
